import { defineMessages } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';
import type { MessageKeyType } from './types';

const i18n: Record<MessageKeyType, MessageDescriptor> = defineMessages({
	defaultAssigneeFieldLabel: {
		id: 'project-details.form.default-assignee.default-assignee-field-label',
		defaultMessage: 'Default assignee',
		description: 'Label for Default Assignee Field',
	},
	projectLeadOption: {
		id: 'project-details.form.default-assignee.project-lead-select-option',
		defaultMessage: 'Project lead',
		description: 'Content for Project lead option under default assignee',
	},
	unassignedOption: {
		id: 'project-details.form.default-assignee.unassigned-select-option',
		defaultMessage: 'Unassigned',
		description: 'Content for Unassigned option under default assignee',
	},
	defaultAssigneeDisabledTooltip: {
		id: 'project-details.form.default-assignee.default-assignee-disabled-tooltip',
		defaultMessage: 'Reach out to your Jira admin to modify the default assignee.',
		description:
			'Tooltip message to show when default assignee is disabled due to allow unassigned property',
	},
});

export default i18n;
